<template>
  <div class="containerRepresentante">
    <DeclaracoesDocumentosList
      :tipoClienteKey="user?.TipoCliente || TIPO_CLIENTE.FUNDOS"
      :showStatusButton="true"
      :showRefresh="true"
      :useImpressaoFlag="false"
    >
      <template #header-extra>
        <LabelDisclaimer
          :TamanhoFonteLabel="'H5'"
          :NomeLabel="'Declarações'"
          :Sessao="'Declarações'"
          :SubSessao="'Declarações'"
        />
      </template>
    </DeclaracoesDocumentosList>
  </div>
</template>

<script>
import DeclaracoesDocumentosList from "@/components/Declaracoes/DeclaracoesDocumentosList.vue";
import LabelDisclaimer from "@/components/LabelDisclaimer.vue";
import { TIPO_CLIENTE } from "@/constants/TipoClienteEnum";

export default {
  name: "CadastroPF_Representantes",
  props: ["Edicao"],
  components: { DeclaracoesDocumentosList, LabelDisclaimer },
  data() {
    return {
      TIPO_CLIENTE,
    };
  },
};
</script>

<style lang="scss" scoped></style>
